import IconSortDownSolid from '@/assets/icons/font_awesome/sort-down-solid.svg?react';
import IconSortUpSolid from '@/assets/icons/font_awesome/sort-up-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_grid2d from '@/locales/keys/i18n_grid2d.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { ENUM__grid2d_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__grid2d_feature';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__tooltip } from '../../../../../components/ui/UI_PRIMITIVE__tooltip';

interface Props {
  grid2d: DTO__grid2d;
  entity: DTO__entity_with_grid2d;
}

export function GRID2D_BUTTON_images_sort({ grid2d, entity }: Props) {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.GRID2D);

  const { user_settings } = use_slice_user(['user_settings']);

  /*
   * STATE
   */
  const [is_loading, set_is_loading] = useState(false);

  const tooltip_title = t(
    user_settings.ui_grid2d_cells_sort_newest_first ? i18n_grid2d.buttons.images_sort.tooltip.new : i18n_grid2d.buttons.images_sort.tooltip.old,
  );

  /*
   * EVENTS
   */
  async function onClick() {
    if (is_loading) return;

    set_is_loading(true);

    let settings_new = user_settings.clone({ ui_grid2d_cells_sort_newest_first: !user_settings.ui_grid2d_cells_sort_newest_first });

    await dispatch(REMOTE__user_settings_update(settings_new));

    set_is_loading(false);
  }

  /*
   * METHODS
   */

  function is_disabled(): boolean {
    return is_loading;
  }

  /*
   * HTML
   */

  if (!entity.is_grid2d_feature_possible(ENUM__grid2d_feature.CELLS__SORT)) return null;
  if (grid2d.total_cells_amount === 0) return null;
  if (grid2d.total_cells_amount === 1) return null;

  return (
    <UI_PRIMITIVE__tooltip {...{ tooltip_title }}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-bar'}
        Icon={user_settings.ui_grid2d_cells_sort_newest_first ? IconSortUpSolid : IconSortDownSolid}
        disabled={is_disabled()}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        {...{ onClick }}
        className="p-0 h-[28px] w-[30px] flex items-center justify-center"
        iconClassNameBase="!text-component-item-foreground !size-4"
        iconClassNameHovered="!text-bar-foreground"
      />
    </UI_PRIMITIVE__tooltip>
  );
}
